import SolelyContent from './solely-content.vue'

export default SolelyContent



// WEBPACK FOOTER //
// ./src/components/solely-content/index.js